import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../../../../_constants/validation-format-constants';
import { DocumentAttachmentRawDto } from './document-attachment-raw-dto';

export class ARPostMiscInvoiceParametersDto {
    customerId: string;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    transactionDate: Date;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    postDate: Date;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    dueDate: Date;

    amount: number;
    appendedDescription: string;
    subLedgerId: number;
    subCategoryCode: string;
    paymentAmountReceived: number;
    checkNumber: string;
    transactionNotes: string;
    @Type(() => DocumentAttachmentRawDto)
    supportingDocument: DocumentAttachmentRawDto;
    invoiceTypeId: number;
    communityId: number;
    managementCompanyId: number;
}
